'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { TypeStyleHeadlineMicro } from '../TypeStyle';
export const InputLabelRequiredAsterisk = styled(({ asTag = 'span', ...rest }) => {
    return (_jsx(TypeStyleHeadlineMicro, { asTag: asTag, ...rest, children: "*" }));
}) `
  padding-left: calc(${o => o.theme.spacing(1)} / 2);
  color: ${o => o.theme.color.text.critical.on.background};
  font-size: 26px;
  line-height: 0px;
  position: relative;
  top: 7px;
`;
//# sourceMappingURL=InputLabelRequiredAsterisk.js.map